import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStickyUtility from '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';
import focusTrapUtility from '@sparta.global.utilities/focus-trap-utility/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$3 = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"logo") : stack1),{"name":"with","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":14},"end":{"line":45,"column":23}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <span itemprop=\"brand\" class=\"ada-hidden\" aria-hidden=\"true\">Bank of America</span>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasLogoLink")),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":14},"end":{"line":33,"column":23}}})) != null ? stack1 : "")
    + "                <img itemprop=\"logo\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__logo-image\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"tagline")),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.program(12, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":36,"column":18},"end":{"line":40,"column":25}}})) != null ? stack1 : "")
    + "\" alt=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"alt") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":32},"end":{"line":40,"column":59}}})) != null ? stack1 : "")
    + "\"\r\n                  src=\""
    + ((stack1 = (lookupProperty(helpers,"prodLogoPath")||(depth0 && lookupProperty(depth0,"prodLogoPath"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"site") : depths[1])) != null ? lookupProperty(stack1,"isProd") : stack1),(depth0 != null ? lookupProperty(depth0,"src") : depth0),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"site") : depths[1])) != null ? lookupProperty(stack1,"isSecure") : stack1),{"name":"prodLogoPath","hash":{},"data":data,"loc":{"start":{"line":41,"column":23},"end":{"line":41,"column":79}}})) != null ? stack1 : "")
    + "\"\r\n                  role=\"img\" />                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasLogoLink")),{"name":"if","hash":{},"fn":container.program(17, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":47},"end":{"line":43,"column":23}}})) != null ? stack1 : "")
    + "\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a itemprop=\"url\" href=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"homeUrl")),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":25,"column":38},"end":{"line":29,"column":25}}})) != null ? stack1 : "")
    + "\"\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":18},"end":{"line":32,"column":25}}})) != null ? stack1 : "")
    + ">\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n                    "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"homeUrl")), depth0))
    + "\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    "
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":28,"column":20},"end":{"line":28,"column":49}}})) != null ? stack1 : "")
    + "\r\n                  ";
},"8":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    title=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":31,"column":27},"end":{"line":31,"column":36}}}) : helper)))
    + "\"\r\n                  ";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__logo-image--narrow\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"brand")),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":18},"end":{"line":40,"column":18}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__logo-image--narrow\r\n                  ";
},"15":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"alt") || (depth0 != null ? lookupProperty(depth0,"alt") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"alt","hash":{},"data":data,"loc":{"start":{"line":40,"column":43},"end":{"line":40,"column":52}}}) : helper)));
},"17":function(container,depth0,helpers,partials,data) {
    return "</a>\r\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <div class=\"header__tagline\">\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"tagline") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.program(22, data, 0),"data":data,"loc":{"start":{"line":50,"column":16},"end":{"line":52,"column":79}}})) != null ? stack1 : "")
    + "\r\n              </div>\r\n";
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression((lookupProperty(helpers,"tagline")||(depth0 && lookupProperty(depth0,"tagline"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"tagline") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"tagline","hash":{},"data":data,"loc":{"start":{"line":50,"column":48},"end":{"line":50,"column":83}}}))
    + "\r\n";
},"22":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + container.escapeExpression((lookupProperty(helpers,"tagline")||(depth0 && lookupProperty(depth0,"tagline"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"array")||(depth0 && lookupProperty(depth0,"array"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"Life","&nbsp;Better&nbsp;Connected",{"name":"array","hash":{},"data":data,"loc":{"start":{"line":52,"column":26},"end":{"line":52,"column":70}}}),{"name":"tagline","hash":{},"data":data,"loc":{"start":{"line":52,"column":16},"end":{"line":52,"column":72}}}));
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"brand") : stack1),{"name":"if","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":54,"column":12},"end":{"line":56,"column":12}}})) != null ? stack1 : "");
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__brand\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"brand") : stack1), depth0))
    + "</div>\r\n            ";
},"27":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__top-nav-sticky\">\r\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"erica-nav"),depth0,{"name":"erica-nav","hash":{"appendToId":"Sticky"},"data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "          </div>\r\n";
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"top-nav"),depth0,{"name":"top-nav","data":data,"indent":"              ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"31":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div id=\"stickyNav\" class=\"show-for-large-up spa-sticky "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__sticky-large-up\">\r\n        <div class=\"row\">\r\n          <div class=\"columns small-12 small-centered\">\r\n            <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__nav-wrapper\">\r\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"main-nav"),depth0,{"name":"main-nav","data":data,"indent":"              ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasGetStartedCta") : stack1),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":79,"column":14},"end":{"line":83,"column":21}}})) != null ? stack1 : "")
    + "            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row collapse hide-for-large-up\">\r\n        <div class=\"columns small-12 small-centered large-12\">\r\n          <div id=\"stickyHeaderMenuContainer\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__dropdown-nav hide-for-large-up\"\r\n            aria-hidden=\"true\">\r\n            <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__dropdown-nav-main\">\r\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"main-nav"),depth0,{"name":"main-nav","hash":{"appendToId":"SmallMedium"},"data":data,"indent":"              ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "            </div>\r\n            <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__dropdown-nav-top\">\r\n              <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__top-nav\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasTopNav") : stack1),{"name":"if","hash":{},"fn":container.program(34, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":99,"column":16},"end":{"line":101,"column":23}}})) != null ? stack1 : "")
    + "              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n";
},"32":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__top-nav-sticky\">\r\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"erica-nav"),depth0,{"name":"erica-nav","hash":{"appendToId":"Sticky"},"data":data,"indent":"                  ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "                </div>\r\n";
},"34":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"top-nav"),depth0,{"name":"top-nav","hash":{"appendToId":"SmallMedium"},"data":data,"indent":"                  ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"spa-sticky "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__sticky-small-med\">\r\n  <header class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__header\">\r\n    <div class=\"row "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__header-row\">\r\n      <div class=\"columns small-12 "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__header-columns\">\r\n\r\n        <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"nameSpace") : stack1), depth0))
    + "__top-nav hide-for-large-up\">\r\n          <a href=\"javascript:void(0);\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__menu-button\" role=\"button\"\r\n            aria-expanded=\"false\" aria-controls=\"stickyHeaderMenuContainer\">\r\n            <span class=\"ada-hidden\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"menu") : stack1)) != null ? lookupProperty(stack1,"showHide") : stack1), depth0))
    + "</span>\r\n            <span class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__menu-button--top\"></span>\r\n            <span class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__menu-button--center\">\r\n              <span class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__menu-button--center-1\"></span>\r\n              <span class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__menu-button--center-2\"></span>\r\n            </span>\r\n            <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__menu-button--bottom\"></div>\r\n          </a>\r\n        </div>\r\n        <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__header-default\">\r\n          <div itemscope itemtype=\"http://schema.org/Corporation\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__logo\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"logo") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":12},"end":{"line":46,"column":19}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteHeader") : depth0)) != null ? lookupProperty(stack1,"tagline") : stack1),{"name":"if","hash":{},"fn":container.program(19, data, 0, blockParams, depths),"inverse":container.program(24, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":48,"column":12},"end":{"line":56,"column":19}}})) != null ? stack1 : "")
    + "          </div>\r\n        </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasGetStartedCta") : stack1),{"name":"if","hash":{},"fn":container.program(27, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":59,"column":8},"end":{"line":63,"column":15}}})) != null ? stack1 : "")
    + "        <span class=\"show-for-large-up text-align-right\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasTopNav") : stack1),{"name":"if","hash":{},"fn":container.program(29, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":12},"end":{"line":67,"column":19}}})) != null ? stack1 : "")
    + "        </span>\r\n      </div>\r\n\r\n    </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"hasMenu") : stack1),{"name":"if","hash":{},"fn":container.program(31, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":72,"column":4},"end":{"line":107,"column":11}}})) != null ? stack1 : "")
    + "  </header>\r\n</div>\r\n";
},"usePartial":true,"useData":true,"useDepths":true});
const renderTemplate$3 = function (data, options) {
  return Template$3(data, options);
};

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <li\r\n        class=\"\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"class") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":10},"end":{"line":6,"column":50}}})) != null ? stack1 : "")
    + "\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"dropDown") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":10},"end":{"line":7,"column":87}}})) != null ? stack1 : "")
    + "\r\n          \"\r\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"dropDown") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":9,"column":44}}})) != null ? stack1 : "")
    + "\r\n      >\r\n        <a id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":11,"column":15},"end":{"line":11,"column":21}}}) : helper)))
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"appendToId") : depths[1]), depth0))
    + "\"\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"id") : depth0),"==",((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"activeNavId")),{"name":"compare","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":10},"end":{"line":13,"column":38}}})) != null ? stack1 : "")
    + "\r\n            href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"url") : depth0), depth0))
    + "\"\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"urlTarget") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":12},"end":{"line":15,"column":58}}})) != null ? stack1 : "")
    + ">\r\n          "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n        </a>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"dropDown") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":28,"column":15}}})) != null ? stack1 : "")
    + "      </li>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"dropDown") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":6},"end":{"line":36,"column":13}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0));
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__main-nav--dropdown-wrapper";
},"6":function(container,depth0,helpers,partials,data) {
    return "tab-index=\"0\"";
},"8":function(container,depth0,helpers,partials,data) {
    return "            class=\"active\"";
},"10":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "target=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"urlTarget") || (depth0 != null ? lookupProperty(depth0,"urlTarget") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"urlTarget","hash":{},"data":data,"loc":{"start":{"line":15,"column":37},"end":{"line":15,"column":50}}}) : helper)))
    + "\"";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__main-nav--dropdown\">\r\n            <ul class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__main-nav--dropdown-list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"dropDown") : depth0)) != null ? lookupProperty(stack1,"items") : stack1),{"name":"each","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":14},"end":{"line":25,"column":23}}})) != null ? stack1 : "")
    + "            </ul>\r\n          </div>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <li class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__main-nav--dropdown-list-item\">\r\n                  "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n                </li>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"dropDown") : depth0)) != null ? lookupProperty(stack1,"items") : stack1),{"name":"each","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":8},"end":{"line":35,"column":17}}})) != null ? stack1 : "");
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <li class=\"hide-for-large-up"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"class") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":38},"end":{"line":32,"column":78}}})) != null ? stack1 : "")
    + "\">\r\n            "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n          </li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<nav role=\"navigation\">\r\n  <ul class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__main-nav\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"mainNav") : depth0)) != null ? lookupProperty(stack1,"mainNav") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":37,"column":13}}})) != null ? stack1 : "")
    + "  </ul>\r\n</nav>\r\n";
},"useData":true,"useDepths":true});
const renderTemplate$2 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__aria-container\" aria-live=\"assertive\" role=\"status\">\r\n    </div>\r\n\r\n    <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-container\"\r\n          aria-hidden=\"true\">\r\n\r\n      <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-cta\">\r\n        <a  href=\"javascript:void(0);\"\r\n            class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-cta--link "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"askEricaLink") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1), depth0)) != null ? stack1 : "")
    + "\"\r\n            id=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"askEricaLink") : stack1)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" role=\"button\">\r\n          <img src=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ericaIconSrc") || (depth0 != null ? lookupProperty(depth0,"ericaIconSrc") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ericaIconSrc","hash":{},"data":data,"loc":{"start":{"line":13,"column":20},"end":{"line":13,"column":38}}}) : helper))) != null ? stack1 : "")
    + "\" alt=\"\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-cta--link-icon\">\r\n          "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"askEricaLink") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </a>\r\n        <span class=\"chat__button--unread hidden\"></span>\r\n      </div>\r\n      <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-cta "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-cta--dropdown-trigger\">\r\n        "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"buttons") : depth0)) != null ? lookupProperty(stack1,"getStartedButton") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":19,"column":8},"end":{"line":19,"column":45}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"dropDown") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":8},"end":{"line":31,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n      <p class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-note\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"note") || (depth0 != null ? lookupProperty(depth0,"note") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"note","hash":{},"data":data,"loc":{"start":{"line":33,"column":56},"end":{"line":33,"column":66}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-cta--dropdown\" aria-labelledby=\"getStartedButton\">\r\n          <ul class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-cta--dropdown-list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"dropDown") : depth0)) != null ? lookupProperty(stack1,"items") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":12},"end":{"line":28,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n        </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__erica-cta--dropdown-list-item\" role=\"presentation\">\r\n                <img src=\""
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"iconSrc") : depth0), depth0)) != null ? stack1 : "")
    + "\" alt=\"\">\r\n                <div>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "")
    + "</div>\r\n              </li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ericaNav") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2},"end":{"line":35,"column":11}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      li."
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"location") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1), depth0))
    + "::before {\r\n      content: url("
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"location") : stack1)) != null ? lookupProperty(stack1,"ICON") : stack1), depth0))
    + ");\r\n    }\r\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasSignIn")),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":34,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasLocation")),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":4},"end":{"line":42,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasContact")),{"name":"if","hash":{},"fn":container.program(18, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":4},"end":{"line":54,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasOpenAccount")),{"name":"if","hash":{},"fn":container.program(28, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":55,"column":4},"end":{"line":71,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"language")),"==","es",{"name":"compare","hash":{},"fn":container.program(31, data, 0, blockParams, depths),"inverse":container.program(35, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":72,"column":4},"end":{"line":93,"column":16}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"signInSmallOnly") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":6},"end":{"line":22,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"signInMediumUp") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":6},"end":{"line":33,"column":13}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\"show-for-small-only "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"login") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1), depth0))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"signInSmallOnly") : depth0),{"name":"with","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":10},"end":{"line":20,"column":19}}})) != null ? stack1 : "")
    + "        </li>\r\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <a class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionType") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":22},"end":{"line":14,"column":71}}})) != null ? stack1 : "")
    + "\"\r\n                id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":15,"column":20},"end":{"line":15,"column":26}}}) : helper)))
    + container.escapeExpression(container.lambda((depths[2] != null ? lookupProperty(depths[2],"appendToId") : depths[2]), depth0))
    + "\"\r\n                href=\""
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":16,"column":22},"end":{"line":16,"column":51}}})) != null ? stack1 : "")
    + "\"\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionType") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":16},"end":{"line":17,"column":83}}})) != null ? stack1 : "")
    + ">\r\n              "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":18,"column":14},"end":{"line":18,"column":29}}}) : helper))) != null ? stack1 : "")
    + "\r\n            </a>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "spa-ui-layer-link spa-fn";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-options=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"actionType") : depth0)) != null ? lookupProperty(stack1,"options") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":17,"column":48},"end":{"line":17,"column":75}}}))
    + "\"";
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\"show-for-medium-up "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"login") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1), depth0))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"signInMediumUp") : depth0),{"name":"with","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":10},"end":{"line":31,"column":19}}})) != null ? stack1 : "")
    + "        </li>\r\n";
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <a class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionType") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":22},"end":{"line":26,"column":71}}})) != null ? stack1 : "")
    + "\"\r\n                id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":27,"column":20},"end":{"line":27,"column":26}}}) : helper)))
    + container.escapeExpression(container.lambda((depths[2] != null ? lookupProperty(depths[2],"appendToId") : depths[2]), depth0))
    + "\"\r\n                href=\""
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":28,"column":22},"end":{"line":28,"column":51}}})) != null ? stack1 : "")
    + "\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionType") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":52},"end":{"line":29,"column":65}}})) != null ? stack1 : "")
    + ">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":29,"column":66},"end":{"line":29,"column":81}}}) : helper))) != null ? stack1 : "")
    + "\r\n            </a>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n                data-options=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"actionType") : depth0)) != null ? lookupProperty(stack1,"options") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":29,"column":30},"end":{"line":29,"column":57}}}))
    + "\"";
},"15":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <li class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"location") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1), depth0))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"locations") : depth0),{"name":"with","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":8},"end":{"line":40,"column":17}}})) != null ? stack1 : "")
    + "      </li>\r\n";
},"16":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <a id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":38,"column":17},"end":{"line":38,"column":23}}}) : helper)))
    + container.escapeExpression(container.lambda((depths[2] != null ? lookupProperty(depths[2],"appendToId") : depths[2]), depth0))
    + "\"\r\n             href=\""
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":39,"column":19},"end":{"line":39,"column":48}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":39,"column":50},"end":{"line":39,"column":65}}}) : helper))) != null ? stack1 : "")
    + "</a>\r\n";
},"18":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <li  class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"contact") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1), depth0))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"contact") : depth0),{"name":"with","hash":{},"fn":container.program(19, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":8},"end":{"line":52,"column":17}}})) != null ? stack1 : "")
    + "      </li>\r\n";
},"19":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <a id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":46,"column":17},"end":{"line":46,"column":23}}}) : helper)))
    + container.escapeExpression(container.lambda((depths[2] != null ? lookupProperty(depths[2],"appendToId") : depths[2]), depth0))
    + "\"\r\n             href=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"contactUrl")),{"name":"if","hash":{},"fn":container.program(20, data, 0, blockParams, depths),"inverse":container.program(22, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":47,"column":19},"end":{"line":51,"column":20}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"contactCopy")),{"name":"if","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.program(26, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":51,"column":22},"end":{"line":51,"column":125}}})) != null ? stack1 : "")
    + "</a>\r\n";
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n               "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"contactUrl")), depth0))
    + "\r\n";
},"22":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "               "
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":50,"column":15},"end":{"line":50,"column":44}}})) != null ? stack1 : "")
    + "\r\n             ";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"siteHeader"))) && lookupProperty(stack1,"contactCopy")), depth0)) != null ? stack1 : "")
    + " ";
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":51,"column":103},"end":{"line":51,"column":118}}}) : helper))) != null ? stack1 : "");
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <li class=\"show-for-small-only small-medium-call-open-account\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"openAccount") : depth0),{"name":"with","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":57,"column":8},"end":{"line":59,"column":17}}})) != null ? stack1 : "")
    + "      </li>\r\n       <li class=\"show-for-medium-only small-medium-call-open-account\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"openAccount") : depth0),{"name":"with","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":62,"column":8},"end":{"line":64,"column":17}}})) != null ? stack1 : "")
    + "      </li>\r\n      <li class=\"show-for-large-up large-call-open-account\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"openAccount") : depth0),{"name":"with","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":67,"column":8},"end":{"line":69,"column":17}}})) != null ? stack1 : "")
    + "      </li>\r\n";
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":58,"column":10},"end":{"line":58,"column":23}}}) : helper))) != null ? stack1 : "")
    + "\r\n";
},"31":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"showEnVersion")),{"name":"if","hash":{},"fn":container.program(32, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":73,"column":6},"end":{"line":82,"column":13}}})) != null ? stack1 : "");
},"32":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\"\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showEnglish") : depth0),{"name":"with","hash":{},"fn":container.program(33, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":75,"column":10},"end":{"line":80,"column":19}}})) != null ? stack1 : "")
    + "        </li>\r\n";
},"33":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <a id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":76,"column":19},"end":{"line":76,"column":25}}}) : helper)))
    + container.escapeExpression(container.lambda((depths[2] != null ? lookupProperty(depths[2],"appendToId") : depths[2]), depth0))
    + "\"\r\n               href=\""
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":77,"column":21},"end":{"line":77,"column":50}}})) != null ? stack1 : "")
    + "\"\r\n               hreflang=\"en\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":78,"column":29},"end":{"line":78,"column":44}}}) : helper))) != null ? stack1 : "")
    + "\r\n            </a>\r\n";
},"35":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"showEsVersion")),{"name":"if","hash":{},"fn":container.program(36, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":84,"column":6},"end":{"line":92,"column":13}}})) != null ? stack1 : "");
},"36":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li>\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"enEsp") : depth0),{"name":"with","hash":{},"fn":container.program(37, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":86,"column":10},"end":{"line":90,"column":19}}})) != null ? stack1 : "")
    + "        </li>\r\n";
},"37":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <a id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":87,"column":19},"end":{"line":87,"column":25}}}) : helper)))
    + container.escapeExpression(container.lambda((depths[2] != null ? lookupProperty(depths[2],"appendToId") : depths[2]), depth0))
    + "\" href=\""
    + ((stack1 = (lookupProperty(helpers,"renderModuleLink")||(depth0 && lookupProperty(depth0,"renderModuleLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"renderModuleLink","hash":{},"data":data,"loc":{"start":{"line":87,"column":53},"end":{"line":87,"column":82}}})) != null ? stack1 : "")
    + "\"\r\n               hreflang=\"es\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":88,"column":29},"end":{"line":88,"column":42}}}) : helper))) != null ? stack1 : "")
    + "\r\n            </a>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<style type=\"text/css\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasLocation")),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":6,"column":11}}})) != null ? stack1 : "")
    + "</style>\r\n<ul class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"nameSpace")), depth0))
    + "__top-nav-links\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"globalHeader") : depth0),{"name":"with","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":2},"end":{"line":94,"column":11}}})) != null ? stack1 : "")
    + "</ul>";
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

/* eslint-disable require-jsdoc */
/*
 * Module helpers for module sticky-header-module.
 * @file
 */

function array(...args) {
  Array.prototype.slice.call(args, 0, -1);
}
function renderModuleLink(href, options) {
  const moduleParams = options.data.root.module;
  const hrefTemplate = Handlebars.compile(href);
  return hrefTemplate({
    module: moduleParams
  });
}
function prodLogoPath(isProd, imagePath, isSecure) {
  let newImagePath = imagePath;
  if (isProd && newImagePath) {
    const match = /https?:\/\//.exec(newImagePath);
    if (!match) {
      newImagePath = `https://${isSecure ? 'secure' : 'www'}.bankofamerica.com${imagePath}`;
    }
  }
  return newImagePath;
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.falcon.modules/sticky-header-module",
  "version": "1.0.7",
  "id": "stickyHeaderModule",
  "containerID": "falconStickyHeaderModule",
  "moduleName": "falcon-sticky-header-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "sticky-header-module",
  "data": {
    "init": "StickyHeaderModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "activeNavId",
    "type": "string",
    "default": "",
    "description": "This parameter sets and highlights the current active navigation item"
  }, {
    "name": "calendarUrl",
    "type": "string",
    "values": [],
    "default": "https://secure.bankofamerica.com/mycommunications/public/appointments/loc.go",
    "description": "Set the href for calendar link in nav"
  }, {
    "name": "contactUrl",
    "type": "string",
    "values": [],
    "default": "https://www.bankofamerica.com/contactus/contactus.go",
    "description": "Set the href for contact link in nav"
  }, {
    "name": "enUrl",
    "type": "boolean",
    "values": ["../"],
    "default": "../",
    "description": "English URL"
  }, {
    "name": "esUrl",
    "type": "boolean",
    "values": ["es"],
    "default": "es",
    "description": "Spanish URL"
  }, {
    "name": "hasContact",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the contact link."
  }, {
    "name": "hasLocation",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the locations link."
  }, {
    "name": "hasLogoLink",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Link to homepage from BofA Logo"
  }, {
    "name": "hasMenu",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the menu button with the arrow."
  }, {
    "name": "hasNavbar",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter allows toggling of the navigation bar beneath the header."
  }, {
    "name": "hasOpenAccount",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the Open Account header copy."
  }, {
    "name": "hasSignIn",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter allows toggling of the sign-in link in the sub nav for both lang links."
  }, {
    "name": "hasTopNav",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter allows toggling of the navigation links in the top right corner of the header"
  }, {
    "name": "helpUrl",
    "type": "string",
    "values": [],
    "default": "https://www.bankofamerica.com/help/overview.go",
    "description": "Set the href for help link in nav"
  }, {
    "name": "helpUrlEs",
    "type": "string",
    "values": [],
    "default": "/homepage/overview.go?request_locale=es_US",
    "description": "Set the href for Spanish home link in nav"
  }, {
    "name": "homeUrl",
    "type": "string",
    "values": [],
    "default": "/",
    "description": "Set the href for home link in nav"
  }, {
    "name": "homeUrlEn",
    "type": "string",
    "values": [],
    "default": "/homepage/overview.go?request_locale=en_US",
    "description": "Set the href for English home link in nav"
  }, {
    "name": "homeUrlEs",
    "type": "string",
    "values": [],
    "default": "/homepage/overview.go?request_locale=es_US",
    "description": "Set the href for Spanish home link in nav"
  }, {
    "name": "locationUrl",
    "type": "string",
    "values": [],
    "default": "https://locators.bankofamerica.com",
    "description": "Set the href for locations link in nav"
  }, {
    "name": "locationUrlEs",
    "type": "string",
    "values": [],
    "default": "https://es-locators.bankofamerica.com/locator/locator/LocatorAction.do",
    "description": "Set the href for the Spanish locations link in nav"
  }, {
    "name": "showEnVersion",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Show the English version if there is one"
  }, {
    "name": "showEsVersion",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Show the spanish version if there is one"
  }, {
    "name": "signInUrlMediumUp",
    "type": "string",
    "values": [],
    "default": "/sitemap/hub/signin.go",
    "description": "Set the href for sign in link in nav"
  }, {
    "name": "signInUrlSmallOnly",
    "type": "string",
    "values": [],
    "default": "https://staticweb.bankofamerica.com/cavmwebbactouch/common/index.html#home?app=signon",
    "description": "Set the href for sign in link in nav"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$3(context, {
      "helpers": {
        array,
        renderModuleLink,
        prodLogoPath,
        link,
        button,
        compare,
        json
      },
      "partials": {
        "main-nav": renderTemplate$2,
        "erica-nav": renderTemplate$1,
        "top-nav": renderTemplate
      }
    });
  },
  "template": renderTemplate$3,
  "partials": {
    "main-nav": renderTemplate$2,
    "erica-nav": renderTemplate$1,
    "top-nav": renderTemplate
  },
  "helpers": {
    array,
    renderModuleLink,
    prodLogoPath,
    link,
    button,
    compare,
    json
  },
  "dependencies": {
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/focus-trap-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.9",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* eslint-disable import/no-unresolved */
const EVENTS = {
  SPARTA_GLOBAL_READY: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility'
};
const NAMESPACE = 'sticky-header-module';
const animationEndEvents = ['animationend', 'webkitAnimationEnd', 'oAnimationEnd'];
const SELECTORS = {
  headerDefault: `.${NAMESPACE}__header-default`,
  headerLogo: `.${NAMESPACE}__logo`,
  ariaContainer: `.${NAMESPACE}__aria-container`,
  ericaGroupLarge: `.show-for-large-up .${NAMESPACE}__erica-container`,
  ericaGroupSmall: `.${NAMESPACE}__sticky-small-med .${NAMESPACE}__erica-container`,
  getStartedButton: '#getStartedButton',
  menuButton: `.${NAMESPACE}__menu-button`,
  menuButtonOpen: `${NAMESPACE}__menu-button--open`,
  menuButtonClose: `${NAMESPACE}__menu-button--close`,
  sticky: `${NAMESPACE}__sticky--active`,
  spaSticky: '.spa-sticky',
  stickySmallMed: `.${NAMESPACE}__sticky-small-med`,
  stickyLargeUp: `.${NAMESPACE}__sticky-large-up`,
  stickyOverflow: `${NAMESPACE}__sticky-overflow`,
  menuContainerId: 'stickyHeaderMenuContainer',
  active: 'active',
  stickyTitle: '.spa-page-title.spa-sticky',
  ericaDropdownTriggerEl: `.${NAMESPACE}__erica-cta--dropdown-trigger .spa-btn`,
  ericaDropdownEl: `.${NAMESPACE}__erica-cta--dropdown`,
  mainNavDropdownTriggerEl: `.${NAMESPACE}__main-nav--dropdown-wrapper a`,
  mainNavDropdownEl: `.${NAMESPACE}__main-nav--dropdown`,
  getStartedBtn: '#getStartedButton'
};

/**
 * The StickyHeaderModule Sparta Module.
 * Sticky navigation module
 * @export
 * @class
 */
class StickyHeaderModule extends Module {
  /**
   * Creates an instance of StickyHeaderModule.
   * @memberof StickyHeaderModule
   * @param {*} options module options
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.mqLargeUp = window.matchMedia('(min-width: 1025px)');
    this.mqLargeDown = window.matchMedia('(max-width: 1024px)');
    this.removedSticky = ''; // track removed sticky

    // how many pixels does the user need to scroll for Erica group to reach final position?
    this.smVertBound = 315;
    this.lgVertBound = 520;
    this.windowHeight = window.innerHeight;
    this.scrollHeight = document.getElementsByTagName('html')[0].scrollHeight;
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @param {object} options The options this module was initialized with.
   * @returns {undefined}
   */
  init() {
    this.setSelectors();
    this.handleMenuButton();
    this.handleDropDownFocus();
    if (this.cannotScrollFully()) {
      /**
       * if we cannot scroll fully because there is not enough page content,
       * or the user's viewport is a large dimension that shows all content,
       * place the Erica group immediately on load
       */
      this.stickyLargeUp.appendChild(this.ericaGroupLarge);
      this.ericaGroupLarge.classList.add('cannot-scroll-fully');
      this.getStartedButton.tabIndex = 0;
    } else {
      this.addLayoutChangeEventListeners();
    }
    const container = this.settings.target;
    this.focusTrap = focusTrapUtility({
      container
    });
    this.Events.sub(EVENTS.SPARTA_GLOBAL_READY, () => {
      this.setStickyElementOnPageLoad();
      this.mqLargeUp.addListener(this.makeNavStickyOnLargeUp.bind(this));
      this.mqLargeDown.addListener(this.makeHeaderStickyOnSmallMed.bind(this));

      // Attach the focus trap on small / medium / zoomed-in devices
      this.mqLargeDown.addListener(() => {
        if (this.isMenuOpened()) {
          this.focusTrap.attachTrap();
        }
      });
      this.mqLargeUp.addListener(() => {
        this.focusTrap.removeTrap();
        if (this.isMenuOpened()) {
          this.closeMenu();
        }
      });
      window.addEventListener('click', clickEvent => {
        this.checkClickOutsideOpenMenu(clickEvent);
      });

      // ensure 'Get started now' button is not focusable before it appears
      if (this.getStartedButton) this.getStartedButton.tabIndex = -1;

      /**
       * Check if Erica button group should be shown on page load
       * i.e. did a user refresh the page further than `Y` px from top?
       */
      this.placeEricaGroupOnRefresh();
    });
  }

  // #region SELECTORS/EVENT LISTENERS =============================================

  /**
   * Set all selectors
   * @return {undefined}
   */
  setSelectors() {
    const {
      target
    } = this.settings;
    this.parent = target;
    this.spaSticky = target.querySelector(SELECTORS.spaSticky);
    this.headerDefault = target.querySelector(SELECTORS.headerDefault);
    this.headerLogo = target.querySelector(SELECTORS.headerLogo);
    this.headerRow = target.querySelector(SELECTORS.headerRow);
    this.ariaContainer = target.querySelector(SELECTORS.ariaContainer);
    this.ericaGroupLarge = target.querySelector(SELECTORS.ericaGroupLarge);
    this.ericaGroupSmall = target.querySelector(SELECTORS.ericaGroupSmall);
    this.getStartedButton = target.querySelector(SELECTORS.getStartedButton);
    this.menuButton = target.querySelector(SELECTORS.menuButton);
    this.stickySmallMed = target.querySelector(SELECTORS.stickySmallMed);
    this.stickyLargeUp = target.querySelector(SELECTORS.stickyLargeUp);
    this.menuContainer = document.getElementById(SELECTORS.menuContainerId);
    this.isStickyTitle = document.querySelectorAll(SELECTORS.stickyTitle).length > 0;
    this.ericaDropdownTriggerEls = Array.from(this.settings.target.querySelectorAll(SELECTORS.ericaDropdownTriggerEl));
    this.ericaDropdownEls = Array.from(this.settings.target.querySelectorAll(SELECTORS.ericaDropdownEl));
    this.mainNavDropdownTriggerEl = this.settings.target.querySelector(SELECTORS.mainNavDropdownTriggerEl);
    this.mainNavDropdownEl = this.settings.target.querySelector(SELECTORS.mainNavDropdownEl);
    this.getStartedBtn = document.querySelector(SELECTORS.getStartedBtn);
  }

  /**
   * Add window event listeners
   * @return {undefined}
   */
  addLayoutChangeEventListeners() {
    ['scroll', 'resize', 'orientationchange'].forEach(event => {
      window.addEventListener(event, () => {
        this.animateBofALogoOnScroll();
        this.positionEricaOnScroll();
      });
    });
    window.addEventListener('orientationchange', () => {
      if (this.isMenuOpened()) {
        this.closeMenu();
      }

      /**
       * Need to recalculate sticky bar state on orientation change to support tablets
       * Note that both functions include viewport dimension checks
       * Place Bank of America logo back in it's initial position
       * Timeout set to allow orientation change to finish before recalculating
       */
      setTimeout(() => {
        this.makeNavStickyOnLargeUp();
        this.makeHeaderStickyOnSmallMed();
      }, 750);
    });
  }

  // #endregion SELECTORS/EVENT LISTENERS =============================================

  // #region MENU ACTIONS/STATE ====================================================

  /**
   * Handle menu button in small and medium viewports
   * @return {undefined}
   */
  handleMenuButton() {
    animationEndEvents.map(endEvent => this.menuButton.addEventListener(endEvent, () => {
      if (this.menuButton.classList.contains(SELECTORS.menuButtonOpen)) {
        this.menuButton.classList.remove(SELECTORS.menuButtonClose);
      }
    }));
    this.menuButton.addEventListener('click', () => {
      if (this.isMenuOpened()) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });
  }

  /**
   * Open menu
   * @return {undefined}
   */
  openMenu() {
    this.spaSticky.style.height = 'auto';
    this.spaSticky.classList.add(SELECTORS.stickyOverflow);
    this.menuButton.classList.add(SELECTORS.menuButtonOpen);
    this.menuButton.classList.remove(SELECTORS.menuButtonClose);
    this.menuButton.setAttribute('aria-expanded', true);
    this.menuContainer.setAttribute('aria-hidden', 'false');
    // CFSSCMONEY-10375 - explicitly set focus on the menu button to mitigate odd focus behavior
    this.menuButton.focus();
    this.focusTrap.attachTrap();
  }

  /**
   * Close menu
   * @return {undefined}
   */
  closeMenu() {
    this.menuButton.classList.add(SELECTORS.menuButtonClose);
    this.menuButton.classList.remove(SELECTORS.menuButtonOpen);
    this.menuButton.setAttribute('aria-expanded', false);
    this.menuContainer.setAttribute('aria-hidden', 'true');
    this.spaSticky.style.height = null;
    this.spaSticky.classList.remove(SELECTORS.stickyOverflow);
    // CFSSCMONEY-10375 - explicitly set focus on the menu button to mitigate odd focus behavior
    this.menuButton.focus();
    this.focusTrap.removeTrap();
  }

  /**
   * Check if menu is opened
   * @return {boolean} `true` if opened, or `false` if closed
   */
  isMenuOpened() {
    return this.menuButton.classList.contains(SELECTORS.menuButtonOpen);
  }

  /**
   * If a click event occurs outside the menu (and button) while menu is open
   * Close the menu
   * @param {MouseEvent} clickEvent the MouseEvent triggered on click
   * @return {undefined}
   */
  checkClickOutsideOpenMenu(clickEvent) {
    if (this.isMenuOpened() && !this.menuContainer.contains(clickEvent.target) && !this.menuButton.contains(clickEvent.target)) {
      this.closeMenu();
    }
  }

  /**
   * Add focus event to dropdown triggers
   * @return {undefined}
   */
  handleDropDownFocus() {
    const showHideEricaDropdownMenu = (eventName, ericaDropdownTrigger) => {
      if (eventName === 'click') {
        // toggle expanded/collapsed view
        const newValue = ericaDropdownTrigger.getAttribute('aria-expanded') === 'true';
        ericaDropdownTrigger.setAttribute('aria-expanded', !newValue);
      } else {
        // if focus or mouseover - always expand
        ericaDropdownTrigger.setAttribute('aria-expanded', true);
      }
    };
    const debounced = _.debounce(showHideEricaDropdownMenu, 200);
    this.ericaDropdownTriggerEls.forEach((el, index) => {
      ['focus', 'mouseover', 'click'].forEach(eventName => {
        el.addEventListener(eventName, () => debounced(eventName, el));
      });
    });
    if (window.innerWidth > 1024) {
      this.ericaDropdownEls.forEach(el => {
        el.querySelector('li:last-child a').addEventListener('blur', () => {
          el.style.display = 'none';
        });
      });
      this.mainNavDropdownTriggerEl.addEventListener('focus', () => {
        this.mainNavDropdownEl.style.display = 'block';
      });
      this.mainNavDropdownEl.querySelector('li:last-child a').addEventListener('blur', () => {
        this.mainNavDropdownEl.style.display = 'none';
      });
    }
  }

  // #endregion MENU ACTIONS/STATE ====================================================

  // #region STICKY MENU ===========================================================

  /**
   * Set sticky element based on media query
   * @return {undefined}
   */
  setStickyElementOnPageLoad() {
    if (this.mqLargeUp.matches) {
      this.makeNavStickyOnLargeUp();
    }
    if (this.mqLargeDown.matches) {
      this.makeHeaderStickyOnSmallMed();
    }
  }

  /**
   * Set navigation bar to be sticky on large up
   * @return {undefined}
   */
  makeNavStickyOnLargeUp() {
    if (this.mqLargeUp.matches) {
      if (this.removedSticky === this.stickyLargeUp) {
        spartaStickyUtility.addStickyEls([this.stickyLargeUp]);
      }
      spartaStickyUtility.removeStickyEls([this.stickySmallMed]);
      this.removedSticky = this.stickySmallMed;
      spartaStickyUtility.recalcStickyEls();
      /**
       * these styles need to be assigned here because CSS class would get overridden on scroll
       * note that translate3d is supported in IE11 and is more performant than translateX, Y etc.
       * https://jsperf.com/translate3d-vs-xy - https://caniuse.com/#feat=transforms3d
       */
      this.headerLogo.style.transform = 'translate3d(0, 0, 0)';
      this.headerLogo.style.opacity = 1;
    }
  }

  /**
   * Set the whole header to be sticky on small and medium,
   * and nav to be sticky on large up
   * @return {undefined}
   */
  makeHeaderStickyOnSmallMed() {
    if (this.mqLargeDown.matches) {
      if (this.removedSticky === this.stickySmallMed) {
        spartaStickyUtility.addStickyEls([this.stickySmallMed]);
      }
      spartaStickyUtility.removeStickyEls([this.stickyLargeUp]);
      this.removedSticky = this.stickyLargeUp;
      spartaStickyUtility.recalcStickyEls();
    }
  }

  // #endregion STICKY MENU ===========================================================

  // #region MENU ANIMATIONS =======================================================

  /**
   * Control entrance/exit animation for the BofA logo on scroll
   * Only animate for small and medium devices
   * @return {undefined}
   */
  animateBofALogoOnScroll() {
    const parentPosition = this.parent.getBoundingClientRect();
    // do not animate if parentPosition.top is positive
    // CFSSCMONEY-10345 - prevent icon shifting down from swipe-to-refresh user gesture
    if (this.mqLargeDown.matches && parentPosition.top <= 0) {
      this.headerLogo.style.transform = `translate3d(0, ${parentPosition.top}px, 0)`;
      this.headerLogo.style.opacity = `${1 + parentPosition.top / 75}`;
      this.headerLogo.style.float = 'right';
    }
  }

  /**
   * Place the Erica button group at its final position
   * @param {HTMLElement} element to position
   * @return {undefined}
   */
  lockEricaGroupAtFinalPosition(element) {
    if (element) {
      const el = element; // avoid function param-reassign
      // these styles need to be assigned here because CSS class would get overridden on scroll
      el.style.transform = 'translate3d(0, 0, 0)';
      el.style.opacity = 1;
      this.headerLogo.style.float = 'left';
      if (this.getStartedButton) this.getStartedButton.tabIndex = 0;
    }

    /**
     * populate aria-container div with Erica element once its position has been reached
     * this should trigger aria-live attribute on the aria-container div
     * this should only happen ONCE or Erica element gets read every time page scrolls
     */
    if (this.ariaContainer && this.ariaContainer.style.display !== 'block') {
      this.ariaContainer.style.display = 'block';
      this.ariaContainer.appendChild(this.ericaGroupSmall);
      this.ericaGroupSmall.setAttribute('aria-hidden', false);
      this.ericaGroupLarge.setAttribute('aria-hidden', false);
    }
  }

  /**
   * Animate the Erica button group based on current vertical scroll position
   * @param {DOMRect} parentPosition the position of the element's parent
   * @param {HTMLElement} element the element to animate
   * @param {Number} verticalBoundary vertical distance until the element is in its final position
   * @param {Number} opacityOffset arbitrary number > 0 adjusts rate of opacity change
   * @return {undefined}
   */
  animateErica(parentPosition, element, verticalBoundary, opacityOffset) {
    if (element) {
      const el = element;
      el.style.transform = `translate3d(${verticalBoundary + parentPosition.top}px, 0, 0)`;
      el.style.opacity = `${-(parentPosition.top / opacityOffset)}`;
    }
  }

  /**
   * Control entrance/exit animation for the Erica button group on scroll
   * Note there are TWO different DOM notes for the Erica button group partial.
   * There are two DOM nodes because there are two different sticky header nodes:
   *  - one for large
   *  - one for small/medium
   * @return {undefined}
   */
  positionEricaOnScroll() {
    const parentPosition = this.parent.getBoundingClientRect();

    // create a smooth entrance animation effect by adjusting x-axis translate
    if (this.mqLargeDown.matches && parentPosition.top > -this.smVertBound) {
      this.animateErica(parentPosition, this.ericaGroupSmall, this.smVertBound, 75);
    }
    if (this.mqLargeUp.matches && parentPosition.top > -this.lgVertBound) {
      this.ericaGroupLarge.style.opacity = 0;
      this.animateErica(parentPosition, this.ericaGroupLarge, this.lgVertBound, 500);
    }

    /**
     * Account for cases where a user:
     * - scrolls quickly
     * - tabs through the page
     * - uses a mouse with high scroll acceleration
     */
    if (this.mqLargeDown.matches && parentPosition.top < -this.smVertBound) {
      this.lockEricaGroupAtFinalPosition(this.ericaGroupSmall);
    }
    if (this.mqLargeUp.matches && parentPosition.top < -this.lgVertBound) {
      this.lockEricaGroupAtFinalPosition(this.ericaGroupLarge);
    }
  }

  /**
   * Check if there is not enough page content to scroll or if the user's viewport
   * prevents Erica group from scrolling into view.
   * @return {Boolean} `true` if not enough viewport to scroll Erica group into its final position
   */
  cannotScrollFully() {
    return this.mqLargeUp.matches && this.scrollHeight - this.windowHeight < this.lgVertBound;
  }

  /**
   * Control Erica button group placement on page load
   * i.e. did a user refresh the page below `Y` px from the top?
   * Then place Erica button group in its final position without animation
   * @return {undefined}
   */
  placeEricaGroupOnRefresh() {
    const distFromTop = this.parent.getBoundingClientRect().top;
    if (this.mqLargeUp.matches && distFromTop < -this.lgVertBound) {
      this.lockEricaGroupAtFinalPosition(this.ericaGroupLarge);
    }
    if (this.mqLargeDown.matches && distFromTop < -this.smVertBound) {
      this.lockEricaGroupAtFinalPosition(this.ericaGroupSmall);
      // Prevent BofA logo from overlapping Erica group on mobile refresh below vertical threshold
      this.headerLogo.style.transform = 'translate3d(0, -1000px, 0)';
    }
  }

  // #endregion MENU ANIMATIONS =======================================================
}
registerModuleClass({
  moduleClass: StickyHeaderModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { StickyHeaderModule as default, moduleConfig };
